import React from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';

const BulletPointListing = (props) => {
  const bulletsList = props?.fields?.items;
  return (
    <div className={clsx('container', 'add-margins', props?.params?.Styles)}>
      <div className="deatilHeader">
        <div className="row align-bottom">
          <div className="col-md-9">
            <h2>
              <Text field={props?.fields?.heading} />
            </h2>
            <p>
              <Text field={props?.fields?.text} />
            </p>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
      <div className="milesBullets">
        <h4>
          <RichText field={props?.fields?.text2} />
        </h4>
        <ul className="row bullet">
          {!!bulletsList &&
            bulletsList?.map((data, index) => {
              return (
                <li className="col-md-6" key={index}>
                  <span className="dash"></span>
                  <h3>
                    <Text field={data?.fields?.heading} />
                  </h3>
                  <p>
                    <Text field={data?.fields?.text} />
                  </p>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};
export default BulletPointListing;
